export const STATUS_LABEL = {
    pending: 'Ожидает',
    processing: 'Оценивается...',
    done: 'Оценено',
    error: 'Ошибка',
};

export const STATUS_COLOR = {
    pending: 'var(--bs-secondary-color)',
    processing: 'var(--bs-warning)',
    done: 'var(--bs-success)',
    error: 'var(--bs-danger)',
};
